module.exports = __webpack_public_path__ + "static/media/oblong_j.90f73808.svg";